"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = require("react-dom");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Backdrop_1 = tslib_1.__importDefault(require("../../components/Backdrop"));
var Loader_1 = tslib_1.__importDefault(require("../../components/Loader"));
var Button_1 = tslib_1.__importDefault(require("../../components/Button"));
var delayUnmounting_1 = tslib_1.__importDefault(require("../../hoc/delayUnmounting"));
var SidebarContainer_1 = tslib_1.__importDefault(require("../SidebarContainer"));
var Form_1 = tslib_1.__importDefault(require("./Form"));
var PagesApi_1 = tslib_1.__importDefault(require("../../PagesApi"));
var DelayedBackdrop = (0, delayUnmounting_1["default"])(Backdrop_1["default"]);
var DelayedSidebarContainer = (0, delayUnmounting_1["default"])(SidebarContainer_1["default"]);
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  * {\n    box-sizing: border-box;\n  }\n"], ["\n  position: relative;\n  * {\n    box-sizing: border-box;\n  }\n"])));
var LoaderOverlay = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var LoaderTitle = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  font-size: 20px;\n  margin-top: 1em;\n"], ["\n  font-size: 20px;\n  margin-top: 1em;\n"])));
var pop = (0, styled_components_1.keyframes)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  0% {\n    transform: scale(0)\n  }\n  60% {\n    transform: scale(1.1)\n  }\n  80% {\n    transform: scale(0.9)\n  }\n  100% {\n    transform: scale(1)\n  }\n"], ["\n  0% {\n    transform: scale(0)\n  }\n  60% {\n    transform: scale(1.1)\n  }\n  80% {\n    transform: scale(0.9)\n  }\n  100% {\n    transform: scale(1)\n  }\n"])));
var popAnimation = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  animation: ", " 0.3s;\n"], ["\n  animation: ", " 0.3s;\n"])), pop);
var SuccessPage = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  ", ";\n"])), popAnimation);
var SuccessTitle = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  font-size: 32px;\n  margin-top: 0.5em;\n  margin-bottom: 1em;\n"], ["\n  font-size: 32px;\n  margin-top: 0.5em;\n  margin-bottom: 1em;\n"])));
var BODY_OVERFLOW_CLASS = 'web-contact-form-opened';
var GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  body.", " {\n    overflow: hidden;\n  }\n"], ["\n  body.", " {\n    overflow: hidden;\n  }\n"])), BODY_OVERFLOW_CLASS);
var Sidebar = /** @class */ (function (_super) {
    tslib_1.__extends(Sidebar, _super);
    function Sidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isSubmitting: false,
            successfullySubmitted: false
        };
        _this.getCheckIcon = function () {
            return (react_1["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 12", width: 120, height: 120 },
                react_1["default"].createElement("path", { fill: "#4CAF50", fillRule: "evenodd", d: "M5.5 11.999L-.001 6.461l1.415-1.413L5.499 9.16 14.585.001l1.416 1.412L5.5 11.999z" })));
        };
        _this.handleClose = function () {
            _this.setState({ isSubmitting: false, successfullySubmitted: false });
            _this.props.onClose();
        };
        _this.handleSubmit = function (values) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var appSpace, e_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('index.tsx {134} values:', values); // REMOVE: remove console log
                        appSpace = this.props.appSpace;
                        this.setState({ isSubmitting: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, PagesApi_1["default"].webContactFormRequest(appSpace, { body: values })];
                    case 2:
                        _a.sent();
                        this.setState({ isSubmitting: false, successfullySubmitted: true });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({ isSubmitting: false });
                        code = e_1.details.code;
                        if (code === 400) {
                            alert('Prosím vyplňte všetky polia a vyberte predmet.');
                        }
                        else {
                            alert('Vyskytla sa chyba, preverte si prosím údaje a skúste to znova');
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Sidebar.prototype.componentDidMount = function () {
        if (this.props.opened === true) {
            document.body.classList.add(BODY_OVERFLOW_CLASS);
        }
    };
    Sidebar.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.opened === false && nextProps.opened === true) {
            document.body.classList.add(BODY_OVERFLOW_CLASS);
        }
        if (this.props.opened === true && nextProps.opened === false) {
            document.body.classList.remove(BODY_OVERFLOW_CLASS);
        }
    };
    Sidebar.prototype.renderSuccessPage = function () {
        return (react_1["default"].createElement(SuccessPage, null,
            this.getCheckIcon(),
            react_1["default"].createElement(SuccessTitle, null, "\u010Eakujeme!"),
            react_1["default"].createElement(Button_1["default"], { onClick: this.handleClose }, "Zavrie\u0165")));
    };
    Sidebar.prototype.render = function () {
        var _a = this.props, opened = _a.opened, _b = _a.subjects, subjects = _b === void 0 ? [] : _b, _c = _a.description, description = _c === void 0 ? null : _c;
        var _d = this.state, isSubmitting = _d.isSubmitting, successfullySubmitted = _d.successfullySubmitted;
        return (0, react_dom_1.createPortal)(react_1["default"].createElement(Wrapper, null,
            react_1["default"].createElement(DelayedBackdrop, { delayTime: 300, isMounted: opened }),
            react_1["default"].createElement(DelayedSidebarContainer, { delayTime: 300, isMounted: opened, onClose: this.handleClose, description: description }, successfullySubmitted ? (this.renderSuccessPage()) : (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(Form_1["default"], { onSubmit: this.handleSubmit, subjects: subjects }),
                isSubmitting && (react_1["default"].createElement(LoaderOverlay, null,
                    react_1["default"].createElement(Loader_1["default"], { size: "xxl" }),
                    react_1["default"].createElement(LoaderTitle, null, "Odosielam V\u00E1\u0161 dopyt ...")))))),
            react_1["default"].createElement(GlobalStyle, null)), document.body);
    };
    return Sidebar;
}(react_1.Component));
exports["default"] = Sidebar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
